import jquery from 'jquery';
import cookie from '@/tools/get-cookie';

export function setupCsrfToken() {
  const csrfTokenElement = document.querySelector("meta[name='csrf-token']");

  const csrfToken = cookie('x_csrf_token') || csrfTokenElement && csrfTokenElement.content;

  if (!csrfToken) {
    console.error("CSRF token not found. AJAX requests may fail.");
    return;
  }

  jquery.ajaxSetup({
    headers: {
      'X-CSRF-Token': csrfToken
    }
  });
}
